module.exports = __webpack_public_path__ + "img/airbnb-logo.9de4cd25.png";